<script>
    import { cog, pieChart, diamond } from 'svelte-awesome/icons';
    import Icon from 'svelte-awesome';

    let cls = "";

    export { cls as class };
    export let style = "";
    export let onlyIcon = false;
    export let scale = 1;
</script>

<button on:click|preventDefault class="settings-button {cls}" class:onlyIcon {style}>
    <Icon scale={1} data={cog}/>
</button>

<style>
    button.onlyIcon {
        border: 0;
        background: 0;
    }
</style>